/**
 * The placeholder a date or time field shows for its format: the format's
 * tokens (`DD.MM.YYYY`, `HH:mm`) are English internals, a German user reads
 * `TT.MM.JJJJ` and `hh:mm`. Separators and the AM/PM token stay as they are.
 * A language without its own letters keeps the tokens.
 */
const TOKEN_LETTERS: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  de: { Y: 'J', D: 'T', H: 'h' },
};

export function formatPlaceholder(format: string, locale: string | undefined): string {
  const letters = TOKEN_LETTERS[(locale ?? '').split('-')[0].toLowerCase()];
  if (!letters) return format;
  return format.replace(/[YDH]/g, (token) => letters[token] ?? token);
}
